import { useLocale } from '@instamenu/context-i18n';
import { Emoji } from '../emoji/emoji';
import { container, description, emoji, title } from './ChartEmpty.css';

export function ChartEmpty() {
  const { i18n } = useLocale();

  return (
    <div className={container}>
      <div className={emoji}>
        <Emoji emoji="👀" ariaLabel="Looking Emoji" />
      </div>
      <div className={title}>{i18n.t('generics.nothingToSee')}</div>
      <div className={description}>{i18n.t('generics.noTransactions')}</div>
    </div>
  );
}

export default ChartEmpty;
